import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/logo/Brix-Logo.png';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import CssBaseline from '@mui/material/CssBaseline';
import useMediaQuery from '@mui/material/useMediaQuery';
import Logout from '../authentication/Logout';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
//import { RootState } from '../store/Store';
//import { RootState } from '../store';
// import { setSelectedProject } from '../store/Projectslice';
// import { setSelectedProjectTitle } from '../store/Projectslice';
import { setSelectedProjectTitle } from '../store/dailylog/Reducer';
import { Avatar, ThemeProvider, Tooltip } from '@mui/material';
import getTheme from '../theme/theme';
//import ProjectManagementPage from '../Views/Management/ProjectManagement';
//import { useLocation } from 'react-router-dom';

//import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
//import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ConstructionIcon from '@mui/icons-material/Construction';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import DriveEtaOutlinedIcon from '@mui/icons-material/DriveEtaOutlined';
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined';
import NoteOutlinedIcon from '@mui/icons-material/NoteOutlined';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import ReportOutlinedIcon from '@mui/icons-material/ReportOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import SubscriptionsOutlinedIcon from '@mui/icons-material/SubscriptionsOutlined';

const drawerWidth = 240;

const iconColor = 'white';

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
  open?: boolean;
}>(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  marginLeft: 0,
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

interface ProjectNames {
  id: number;
  project_name: string;
}

interface HeaderProps {
  children: React.ReactNode;
  projectName: ProjectNames[];
  visibleFlag: boolean; multiSelectFlag: boolean; defaultProjectName: string;
  setDefaultProjectName: (newProjectName: string) => void;
}

interface DrawerLog {
  assignedto: string;
  createddate: string;
  projectcode: string;
  status: string;
  title: string;
}

interface ProjectNames {
  id: number;
  project_name: string;
}

//const Header: React.FC<HeaderProps> = ({ children }) => {
const Header: React.FC<HeaderProps> = ({ projectName, visibleFlag, setDefaultProjectName, multiSelectFlag, defaultProjectName, children }) => {
  const navigate = useNavigate();
  const theme = getTheme();
  const [isDropdownOpen, setIsDropdownOpen] = useState(visibleFlag);
  //  const [project, setProject] = React.useState('');
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Determine if the screen size is mobile
  const [open, setOpen] = React.useState(!isMobile); // Initialize open state based on whether the screen is mobile
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [drawerLogs, setDrawerLogs] = useState<DrawerLog[]>([]);
  const dispatch = useDispatch();
  //  const [selectedTitle, setSelectedTitle] = React.useState(defaultProjectName);
  //  const selectedProject = useSelector((state: RootState) => state.project.selectedProject);

  const [projectNamesData, setProjectNamesData] = useState<ProjectNames[]>([]);
  const userraccess = JSON.parse("" + localStorage.getItem('userrole'));
  const ReportAccess = userraccess?.reportsaccess;

//   let featuresDetails = localStorage.getItem('featuresDetails');
//   // Check if the value exists and parse it into an array
// if (featuresDetails) {
//   featuresDetails = JSON.parse(featuresDetails);
// } else {
//   // If nothing exists in localStorage, initialize with an empty array
//   featuresDetails = [];
// }

// // Add the new feature
// featuresDetails.push({ name: "Invoice Template" });

// // Save the updated array back to localStorage
// localStorage.setItem('featuresDetails', JSON.stringify(featuresDetails));

// Retrieve the existing features details from localStorage
let featuresDetails: string | null = localStorage.getItem('featuresDetails');

// Check if the value exists and parse it into an array
let parsedFeaturesDetails: { name: string }[] = [];

if (featuresDetails) {
  parsedFeaturesDetails = JSON.parse(featuresDetails);
}

// Add the new feature
parsedFeaturesDetails.push({ name: "Invoice" });

// Save the updated array back to localStorage
localStorage.setItem('featuresDetails', JSON.stringify(parsedFeaturesDetails));

// Log the updated array to the console
  let features: any = null;

  if (featuresDetails) {
    features = JSON.parse(featuresDetails);
  } else {
    navigate('/login');
  }
  // console.log("featuressub:",features);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };


  useEffect(() => {
    // Here, we set the projectNamesData fetched in App.tsx
    setProjectNamesData(projectName);
    setIsDropdownOpen(visibleFlag)

  }, [projectName, visibleFlag, defaultProjectName]); // Add projectName to dependency array

  /*
    useEffect(() => {
      const fetchDailyLogs = async () => {
        try {
          const response = await axios.get('http://localhost:8000/dailylogs/', {
            headers: {
              Accept: 'application/json',
            },
          });
          setDrawerLogs(response.data.dailylogs);
          console.log("Daily",response.data);
  
          const response1 = await axios.get('http://localhost:8000/projects/names', {
            headers: {
              Accept: 'application/json',
            },
          });
          const projectNamesData = response1.data.project_names;
          setProjectNamesData(projectNamesData)
          console.log("project names", projectNamesData)
  
  
        } catch (error) {
          console.log(error);
        }
      };
      fetchDailyLogs();
    }, []);
  */

  const projectTitle = drawerLogs.map((log, index) => ({
    title: log.title,
  }));


  useEffect(() => {
    const isAuthenticated = localStorage.getItem('token');
    setIsLoggedIn(!!isAuthenticated);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    navigate('/home'); // Redirect to home page after logout
  };

  const dailylogs = () => {
    navigate('/dailylogs');
  };
  const servicetickets = () => {
    navigate('/servicetickets');
  };
  const punchlists = () => {
    navigate('/punchlists');
  };
  const todolists = () => {
    navigate('/todolists');
  };
  const inspections = () => {
    navigate('/inspections');
  };

  const safetylogs = () => {
    navigate('/safetylogs');
  };
  const vehiclelogs = () => {
    navigate('/vehiclelogs');
  };

  const projmgmt = () => {
    navigate('/projmgmt');
  };

  const projectschedule = () => {
    navigate('/projectschedule');
  };


  const useraccount = () => {
    navigate('/useraccount');
  };


  const subscriptions = () => {
    navigate('/subscriptions');
  };

  const usersupport = () => {
    navigate('/usersupporthome')
  };

  const showreport = () => {
    navigate('/reports')
  };

  const search = () => {
    navigate('/search');
  };

  const workorders = () => {
    navigate('/workorders');
  };

  const invoicetemp = () => {
    navigate('/createinvoice');
  };


  // Inside Header component's handleChange function
  const handleChange = (event: SelectChangeEvent<string>) => {

    const selectedProjectTitle = event.target.value as string;

    let l_selectedId = '0';
    if (selectedProjectTitle.length !== 0)
      l_selectedId = selectedProjectTitle
    setDefaultProjectName(l_selectedId)
    //  setSelectedTitle(l_selectedId);
    dispatch(setSelectedProjectTitle(l_selectedId)); // Update selected project title in Redux
  };


  const CustomDrawer = styled(Drawer)(({ theme }) => ({
    '& .MuiDrawer-paper': {
      width: drawerWidth,
      boxSizing: 'border-box',
      backgroundColor: '#363537', // Use the background color defined in the theme
      color: theme.palette.text.primary, // Use the text color defined in the theme
    },
  }));

  const linkStyles = {
    textDecoration: 'none',
    marginTop: '7px',
    marginLeft: '-11px',
  };

  //  const handleOpenClose = () => {
  //    setIsDropdownOpen((prevOpen) => !prevOpen);
  //setIsDropdownOpen(true);
  //  };


  //    const [showProjectDropdown, setShowProjectDropdown] = useState(true); // Initially show the project dropdown
  //    const location = useLocation();

  //  useEffect(() => {
  //   setShowProjectDropdown(location.pathname !== '/useraccount');
  // }, [location.pathname]);


  // Define the possible features
  const possibleFeatures = [
    //'Features',
    'Project Management',
    'Project Schedule',
    'Daily logs',
    'Invoice',
    'Work Orders',
    'Service Tickets',
    'Punchlists',
    'To-do lists',
    'Inspections',
    'Safety logs',
    'Vehicle logs',
    'Reports',
    'Search',

  ];
  const featurelist = ['User Account', 'Subscriptions', 'User Support']

  // Filter the possible features based on the features fetched from localStorage
  //  const availableFeatures = possibleFeatures.filter(feature => {
  //    return features.some((f: { name: string }) => f.name.toLowerCase() === feature.toLowerCase());
  //  });

  // Check if features is empty
  // Check if features is empty
  // let availableFeatures: any[] = [];

  // // Check for empty features list
  // if (features.length === 0) {
  //   availableFeatures = [...possibleFeatures];
  // } else {
  //   availableFeatures = possibleFeatures.filter(feature => {
  //     return features.some((f: { name: string }) => f.name.toLowerCase() === feature.toLowerCase());
  //   });
  // }

  // Check for empty features list safely
let availableFeatures: string[] = [];

// Ensure 'features' is an array
if (!Array.isArray(features)) {
  console.warn('Features is not an array. Using all possible features as a fallback.');
  availableFeatures = [...possibleFeatures];
} else if (features.length === 0) {
  availableFeatures = [...possibleFeatures]; // Use all features if 'features' is empty
} else {
  availableFeatures = possibleFeatures.filter(feature => {
    return features.some((f: { name: string }) => f.name.toLowerCase() === feature.toLowerCase());
  });
}


  // Apply reports access control
  if (ReportAccess !== "Owner") {
    availableFeatures = availableFeatures.filter(feature => feature !== 'Reports');
  }

  // Apply project management access control
  const projectAccess = userraccess?.projectaccess;
  if (projectAccess === 'No Access') {
    availableFeatures = availableFeatures.filter(feature => feature !== 'Project Management');
  }

  // Apply project schedule access control
  const scheduleAccess = userraccess?.scheduleaccess;
  if (scheduleAccess === 'No Access') {
    availableFeatures = availableFeatures.filter(feature => feature !== 'Project Schedule');
  }

  // Apply modules access control
  const modulesAccess = userraccess?.modulesaccess;
  if (modulesAccess === 'No Access') {
    const modules = [
      'Daily logs',
      'Invoice',
      'Work Orders',
      'Service Tickets',
      'Punchlists',
      'To-do lists',
      'Inspections',
      'Safety logs',
      'Vehicle logs',
    ];
    availableFeatures = availableFeatures.filter(feature => !modules.includes(feature));
  }

  // const availableFeaturelist = featurelist.filter(feature => {
  //   return features.some((f: { name: string }) => f.name.toLowerCase() === feature.toLowerCase());
  // });

  const username = localStorage.getItem('username') ?? '';
  const email = JSON.parse("" + localStorage.getItem('email')) ?? '';

  const getInitials = (name: string): string => {
    const initials = name.split(' ').map((word: string) => word[0]).join('');
    return initials.toUpperCase();
  };

  const initials = getInitials(username);

  return (
    <ThemeProvider theme={getTheme()}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        {/* <AppBar position='fixed' sx={{ pt: '5',pb:'7px'}}> */}
        <AppBar position='fixed' sx={{ padding: '6px 0', backgroundColor: '#363537' }}>
          <Toolbar>
            {isMobile && ( // Render the menu icon only on mobile screens
              <IconButton
                color='inherit'
                aria-label='open drawer'
                onClick={handleDrawerToggle} // Toggle the drawer open/close state
                edge='start'
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
            )}
            <Box sx={{ display: 'flex', alignItems: 'center', marginRight: 6 }}>
              <Link to='/projmgmt' style={linkStyles}>
                <img src={logo} alt='logo' height={60} width={185} />
              </Link>
            </Box>

            {isDropdownOpen ? (
              <FormControl sx={{ m: 1, minWidth: 120, flex: '1', }} size='small'>
                <Box component="span" sx={{ mt:'-20px',color: 'white' }}>
                  Select Project
                </Box>
                {/* <InputLabel id='proj-input'>
                  Project
                </InputLabel> */}
                <Select
                  labelId='project-select-label'
                  id='project-select'
                  value={defaultProjectName}
                  label={defaultProjectName}
                  onChange={handleChange}
                >
                  <MenuItem value='0'>
                    <em>All</em>
                  </MenuItem>
                  {/* {projectTitle.map((title, index) => (
                <MenuItem key={index} value={title.title}>
                  {title.title}
                </MenuItem>
              ))} */}
                  {projectNamesData.map((project, index) => (
                    <MenuItem key={index} value={project.id}>
                      {project.project_name}
                    </MenuItem>
                  ))}
                </Select>

                {/* <Select
              labelId='select-medium-label'  id='select-medium'
                value={selectedTitle} label='Project' onChange={handleChange}
            >
              <MenuItem value='0'>
                <em>None</em>
              </MenuItem>
              {projectNamesData.map((project, index) => (
            <MenuItem key={index} value={project.id}>
              {project.project_name}
            </MenuItem>
          ))}
          
          </Select> */}

              </FormControl>
            ) : (null)
            }
            {/* <ProjectDropdown /> */}
            <Box sx={{ flexGrow: 1 }} />
            {/* <Button variant='contained' onClick={dailylogs}>
            Logout
          </Button> */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Logout onLogout={handleLogout} />
              <Tooltip
                title={
                  <Box sx={{ fontSize: '1.5em', p: 1, bgcolor: 'primary.main', color: '#333333', boxShadow: 'none' }}>
                    <div>{username}</div>
                    <div>{email}</div>
                  </Box>
                }
                PopperProps={{
                  sx: {
                    '.MuiTooltip-tooltip': {
                      bgcolor: 'primary.main', // Ensure the background color of the tooltip is primary
                      color: '#333333',        // Use a duller shade of black
                      border: 'none',          // Remove any border
                      boxShadow: 'none',       // Remove any box shadow
                    }
                  }
                }}
              >
                <Avatar sx={{ bgcolor: 'primary.main', color: 'black', width: 45, height: 45 }}>{initials}</Avatar>
              </Tooltip>
            </div>
          </Toolbar>
        </AppBar>

        {/*
        <Box sx={{ backgroundColor: 'white', padding: '20px' }}>
          <IconButton onClick={handleOpenClose} aria-label={isDropdownOpen ? "Collapse" : "Expand"}>
            {isDropdownOpen ? <KeyboardDoubleArrowRightIcon /> : <KeyboardDoubleArrowLeftIcon />}
          </IconButton>
        </Box>
    */}

        {isDropdownOpen ? (
          <>
            <Drawer
              sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                  width: drawerWidth,
                  boxSizing: 'border-box',
                  // backgroundColor: '#363537',
                  // color: '#FCFFF8' //Powder white for drawer text

                },
                '& .MuiListItem-root:hover': {
                  // backgroundColor: '#CAFF59', // Change background color on hover
                  // backgroundColor: theme.palette.primary.main,
                  // color: 'black', // Change text color on hover
                },
              }}
              variant={isMobile ? 'temporary' : 'persistent'} // Change variant based on screen size
              anchor='left'
              open={open}
              onClose={handleDrawerToggle} // Close the drawer when clicked outside on mobile
            >

              <DrawerHeader>
                <IconButton onClick={handleDrawerToggle}>
                  {theme.direction === 'ltr' ? (
                    <ChevronLeftIcon />
                  ) : (
                    <ChevronRightIcon />
                  )}
                </IconButton>
              </DrawerHeader>
              <Divider />

              <Box sx={{ marginTop: 2 }}> {/* Add margin top to create space */}
                <Typography>
                  <List>
                    {
                      availableFeatures
                        .map((text, index) => (
                          <ListItem key={text} disablePadding>
                            <ListItemButton
                              onClick={
                                text === 'Project Schedule'
                                  ? projectschedule
                                  : text === 'Project Management'
                                    ? projmgmt

                                    : text === 'Daily logs'
                                      ? dailylogs
                                      : text === 'Invoice'
                                      ? invoicetemp
                                      : text === 'Work Orders'
                                        ? workorders
                                        : text === 'Service Tickets'
                                          ? servicetickets
                                          : text === 'Punchlists'
                                            ? punchlists
                                            : text === 'To-do lists'
                                              ? todolists
                                              : text === 'Inspections'
                                                ? inspections
                                                : text === 'Safety logs'
                                                  ? safetylogs
                                                  : text === 'Vehicle logs'
                                                    ? vehiclelogs
                                                    : text === 'Reports'
                                                      ? showreport
                                                      : text === 'Search'
                                                        ? search

                                                        : undefined

                              }
                              sx={{ paddingTop: 2 }}
                            >
                              <ListItemIcon>
                                {/* {index % 2 === 0 ? <InboxIcon /> : <MailIcon />} */}
                                {text === 'Search' ? <SearchOutlinedIcon sx={{
                                  color: iconColor,
                                  '&:hover': { color: 'black' },
                                }} />
                                  : text === 'Project Schedule' ? <CalendarMonthIcon sx={{
                                    color: iconColor,
                                    '&:hover': { color: 'black' },
                                  }} />
                                    : text === 'Vehicle logs' ? <DriveEtaOutlinedIcon sx={{
                                      color: iconColor,
                                      '&:hover': { color: 'black' },
                                    }} />
                                      : text === 'Safety logs' ? <LockOutlinedIcon sx={{
                                        color: iconColor,
                                        '&:hover': { color: 'black' },
                                      }} />
                                        : text === 'Work Orders' ? <ConstructionIcon sx={{
                                          color: iconColor,
                                          '&:hover': { color: 'black' },
                                        }} /> : text === 'Reports' ? <ArticleOutlinedIcon sx={{
                                          color: iconColor,
                                          '&:hover': { color: 'black' },
                                        }} /> :
                                          text === 'Daily logs' ? <NoteAltOutlinedIcon sx={{
                                            color: iconColor,
                                            '&:hover': { color: 'black' },
                                          }} /> : text === 'Invoice' ? <NoteAltOutlinedIcon sx={{
                                            color: iconColor,
                                            '&:hover': { color: 'black' },
                                          }} />
                                            : text === 'Project Management' ? <NoteOutlinedIcon sx={{
                                              color: iconColor,
                                              '&:hover': { color: 'black' },
                                            }} />
                                              : text === 'Punchlists' ? <PlaylistAddCheckOutlinedIcon sx={{
                                                color: iconColor,
                                                '&:hover': { color: 'black' },
                                              }} />
                                                : text === 'To-do lists' ? <ListAltOutlinedIcon sx={{
                                                  color: iconColor,
                                                  '&:hover': { color: 'black' },
                                                }} /> :
                                                  text === 'Inspections' ? <ReportOutlinedIcon sx={{
                                                    color: iconColor,
                                                    '&:hover': { color: 'black' },
                                                  }} />
                                                    : text === 'Service Tickets' ? <AssignmentIndOutlinedIcon sx={{
                                                      color: iconColor,
                                                      '&:hover': { color: 'black' },
                                                    }} /> : <MailIcon />}
                              </ListItemIcon>
                              <ListItemText primary={text} />
                            </ListItemButton>
                          </ListItem>
                        ))}
                  </List>
                </Typography>
              </Box>
              <Divider />
              <List>
                {/* {['User Account', 'Subscriptions', 'User Support'].map( */}
                {featurelist.map(
                  (text, index) => (
                    <ListItem key={text} disablePadding>
                      <ListItemButton
                        onClick={
                          text === 'User Account'
                            ? useraccount
                            : text === 'Subscriptions'
                              ? subscriptions
                              : text === 'User Support'
                                ? usersupport
                                : undefined
                        }>
                        <ListItemIcon >
                          {text === 'User Account' ? <PersonAddAltOutlinedIcon sx={{
                            color: iconColor,
                            '&:hover': { color: 'black' },
                          }} />
                            : text === 'Subscriptions' ? <SubscriptionsOutlinedIcon sx={{
                              color: iconColor,
                              '&:hover': { color: 'black' },
                            }} />
                              : text === 'User Support' ? <EmailOutlinedIcon sx={{
                                color: iconColor,
                                '&:hover': { color: 'black' },
                              }} />
                                : undefined}
                        </ListItemIcon>
                        <ListItemText primary={text} />
                      </ListItemButton>
                    </ListItem>
                  )
                )}

              </List>
            </Drawer>

          </>
        ) : (null)
        }


        <Main>
          <DrawerHeader />
          {children}
        </Main>
      </Box>
    </ThemeProvider>
  );
};

export default Header;